




import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Observer extends Vue {
  observer: any = null;

  mounted() {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.$emit("intersect");
      }
    });

    this.observer.observe(this.$el);
    console.warn("im observer");
  }
}
